import actions from '../../actionTypes';

export default (azones) => {
  return {
    type: actions.EDIT_AREA_READY,
    azones
  };
};



// WEBPACK FOOTER //
// ./src/reducers/areas/actions/editAreaReady.js